import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-input',
    template: `<div>
    <ngl-input [label]="to.label || ''" (input)="handleInputChange(field)">
      <input
        ngl
        [name]="key"
        type="input"
        [formControl]="$any(formControl)"
        [formlyAttributes]="field"
        class="custom-class"
        [autocomplete]="to.attributes?.['autocomplete'] || 'nope'"
        [required]="$any(to.required)"
      />
    </ngl-input>
  </div>`,
    styleUrls: ['./input.type.component.scss'],
    standalone: false
})
export class InputTypeComponent extends FieldType {
  public handleInputChange(field?: FormlyFieldConfig): void {
    if (field?.templateOptions && field.templateOptions['onChange']) {
      const value = this.model[this.key.toString()];
      field.templateOptions['onChange'](this, value, this.model);
    }
  }
}
